export default {
  project: 'ADMIN_PROJECT',
  field: 'ADMIN_PROJECT_FIELD',
  description: 'ADMIN_PROJECT_DESCRIPTION',
  subtargets: 'ADMIN_PROJECT_SUBTARGETS',
  subtargetsFields: 'ADMIN_PROJECT_SUBTARGETS_FIELDS'
};
